module.exports = __webpack_public_path__ + "static/img/28.25b775b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/28.png
// module id = se6i
// module chunks = 0